// extracted by mini-css-extract-plugin
module.exports = {"blockOptionIconContainer":"BlockTypeButton_blockOptionIconContainer__2AG-9","optionBlockButton":"BlockTypeButton_optionBlockButton__nn1zb"};